var _a, _StreamEmbedLinkUtils_getLocalLink, _StreamEmbedLinkUtils_getTwitchLink;
import { __classPrivateFieldGet } from "tslib";
export class StreamEmbedLinkUtils {
    static getLink(info) {
        switch (info.platform) {
            case 'local':
            case 'totoro':
                return __classPrivateFieldGet(this, _a, "m", _StreamEmbedLinkUtils_getLocalLink).call(this, info);
            case 'twitch':
                return __classPrivateFieldGet(this, _a, "m", _StreamEmbedLinkUtils_getTwitchLink).call(this, info);
            default:
                return info.url;
        }
    }
}
_a = StreamEmbedLinkUtils, _StreamEmbedLinkUtils_getLocalLink = function _StreamEmbedLinkUtils_getLocalLink(info) {
    const { host } = location;
    const { keyid, platform } = info;
    return `//${host}/embed?id=${keyid}&p=${platform}`;
}, _StreamEmbedLinkUtils_getTwitchLink = function _StreamEmbedLinkUtils_getTwitchLink(info) {
    const { hostname } = location;
    const { url: link } = info;
    const url = new URL(link, location.href);
    const params = new URLSearchParams(url.search);
    params.append('parent', hostname);
    url.search = params.toString();
    return `${url.toString()}`;
};
